export const stripeKey = "pk_test_tAMChOZmT4OHrVNyhGvJmuLH";


// QA: "pk_test_tAMChOZmT4OHrVNyhGvJmuLH";
// Prod: "pk_live_9Kcag7bFv5h1BM96L9FBDWxa";
